import { gql } from '@apollo/client';

export const TEST_EXECUTION_EXECUTE_TESTS = gql`
  mutation TestExecutionExecuteTests(
    $contexts: [ExecuteTestsContextsInput]
    $name: String
    $description: String!
    $attEnv: String!
    $smokeTest: Boolean!
    $filters: JSON
    $region: String!
    $userId: ID!
    $includeTrackingValidations: Boolean
    $executionType: String
  ) {
    testsExecutionExecuteTest(
      contexts: $contexts
      name: $name
      description: $description
      userId: $userId
      attEnv: $attEnv
      smokeTest: $smokeTest
      filters: $filters
      region: $region
      includeTrackingValidations: $includeTrackingValidations
      executionType: $executionType
    ) {
      duration
      start
      status
      executionStatus
      name
      description
      attEnv
      _id
      executionType
    }
  }
`;

export const TEST_EXECUTION_RERUN_TESTS = gql`
  mutation TestExecutionRerunTests($name: String, $teId: ID!, $userId: ID!) {
    testsExecutionReRunExecuteTestResolver(
      name: $name
      userId: $userId
      teId: $teId
    ) {
      duration
      start
      status
      executionStatus
      name
      attEnv
      _id
    }
  }
`;

export const UPDATE_AI_ANALYSIS = gql`
  mutation UpdateAIAnalysis(
    $id: MongoID!
    $record: UpdateByIdRagAnalysisInput!
  ) {
    ragAnalysisSchemaUpdateById(_id: $id, record: $record) {
      record {
        isFalsePositive
        metadata {
          status
        }
      }
    }
  }
`;
